export default function (app) {
  return {
    state: {
      reportBlocks: [],
    },
    getters: {

    },
    actions: {
      async getReportBlocks({ commit, state: { licenseKey, }, }) {
        try {
          commit('setLoading', true);
          const reportBlocks = await app.service('reports').get(licenseKey);

          commit('setReportBlocks', reportBlocks);

          await new Promise(resolve => setTimeout(resolve, 4000));
          commit('setLoading', false);
        } catch (e) {
          commit('setLoading', false);
          throw e;
        }
      },
    },
    mutations: {
      setReportBlocks: (state, reportBlocks) => state.reportBlocks = reportBlocks,
    },
  };
}
